import { lazy, Suspense } from 'react'

const SettingsPage = lazy(async () => {
  const module = await import('@/features/settings/SettingsPage')
  return { default: module.SettingsPage }
})

export function SettingsRoute() {
  return (
    <Suspense fallback={<p role="status">正在加载页面…</p>}>
      <SettingsPage />
    </Suspense>
  )
}
